import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '#/redux/modules/user/actions';
import { sendScreenView } from '#/redux/modules/firestore/actions';
import { actions as modalActions } from '#/redux/modules/modal/actions';
import {
  onboardingStepOneDesc,
  onboardingStepOneTitle,
  onboardingStepOnePrivacy,
} from '#/config/strings';
import { getSensicalTvConfig } from '#/redux/modules/accedoOne/selectors';
import { Button, StepIndicator, DigitEntry } from '#/widgets/ui';
import { authScreenNames } from '#/config/constants';
import Logo from '#/static/images/icons/logo.svg';
import Exit from '#/static/images/icons/exit.svg';
import GreenBackground from '#/static/images/background-images/Green.svg';

import { authFlowRoutes } from '#/utils/routes';
import authStyles from '../authflow.scss';
import CancelButton from '../CancelButton';

import styles from './AgeGate.scss';

const AgeGate = ({ history }) => {
  const dispatch = useDispatch();
  const [ageValid, setAgeValid] = useState(false);
  const [year, setYear] = useState(null);
  const [showPrivacy, setShowPrivacy] = useState(true);

  const { logoUri = '' } =
    useSelector(state => getSensicalTvConfig(state)) || {};

  const onSubmit = useCallback(() => {
    if (ageValid) {
      dispatch(actions.setAgeVerified({ ageVerified: true }));
      history.push(authFlowRoutes.PROFILE_CREATION);
    }
  }, [ageValid, history, dispatch]);

  useEffect(() => {
    dispatch(sendScreenView(authScreenNames.AGE_GATE));
  }, []);

  return (
    <div
      className={cx(
        authStyles.authFlow,
        authStyles.onboardFlow,
        styles.ageGate,
      )}
      style={{ backgroundImage: `url(${GreenBackground})` }}
    >
      <CancelButton />
      <StepIndicator step="1" />
      <img className={styles.logo} src={logoUri || Logo} alt="Logo" />
      <div
        className={`${authStyles.pageDescription} ${authStyles.verifyAgeDescription}`}
      >
        <h1 className={authStyles.title}>{onboardingStepOneTitle}</h1>
        <p className={authStyles.stepOneDesc}>{onboardingStepOneDesc}</p>
      </div>
      <div className={styles.ageEntryContainer}>
        <DigitEntry
          onChange={(valid, value) => {
            setAgeValid(valid);
            setYear(value);
          }}
          onSubmit={onSubmit}
          validator={value => {
            const currentYear = new Date().getFullYear();
            return currentYear - value >= 18 && currentYear - value < 124;
          }}
        />
        <p
          className={cx(styles.error, {
            [styles.visible]: !!year && !ageValid,
          })}
        >
          You must be an adult to sign up for Sensical
        </p>
      </div>
      <Button
        onClick={onSubmit}
        selected={ageValid}
        className={(!ageValid && 'static') || ''}
      >
        Continue
      </Button>
      {showPrivacy && (
        <div className={authStyles.privacyContainer}>
          <span>
            {onboardingStepOnePrivacy}
            <span
              className={authStyles.privacyAction}
              onClick={() =>
                dispatch(
                  modalActions.openModal({ modalId: 'PrivacyAgreementModal' }),
                )
              }
            >
              privacy policy
            </span>
          </span>

          <div
            className={authStyles.privacyClose}
            style={{ backgroundImage: `url(${Exit})` }}
            onClick={() => setShowPrivacy(false)}
            alt="Close"
          />
        </div>
      )}
    </div>
  );
};
AgeGate.propTypes = {
  history: PropTypes.object,
};

export default AgeGate;
